import React from 'react';
import DawaAutocomplete from '@/components/dawa/DawaAutocomplete';
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

const EditBuildingDialog = ({
  open,
  onClose,
  building,
  triggerGetLocation,
  handleEditBuilding,
}) => {
  const [formState, setFormState] = React.useState({
    Name: building.name || '',
    AccountId: building.accountId || 0,
    BaselineDayInterval: building.baselineDayInterval || 10,
    BaselineDayOffset: building.baselineDayOffset || 'PT12H',
    AllowSaturdayBaselineDay: building.allowSaturdayBaselineDay ?? true,
    Location: {
      Address: building.address || '',
      Latitude: building.latitude || null,
      Longitude: building.longitude || null,
    },
    UserInput: building.userInput,
  });

  React.useEffect(() => {
    if (building) {
      setFormState({
        Name: building.name || '',
        AccountId: building.accountId || 0,
        BaselineDayInterval: building.baselineDayInterval || 10,
        BaselineDayOffset: building.baselineDayOffset || 'PT12H',
        AllowSaturdayBaselineDay: building.allowSaturdayBaselineDay ?? true,
        Location: {
          Address: building.address || '',
          Latitude: building.latitude || null,
          Longitude: building.longitude || null,
        },
        UserInput: building.userInput,
      });
    }
  }, [building]);

  const handleSubmit = () => {
    if (formState.Name && formState.Location.Address) {
      handleEditBuilding(formState);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit Building</DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Navn"
          value={formState.Name}
          required
          error={!formState.Name}
          onChange={(e) =>
            setFormState((prev) => ({
              ...prev,
              Name: e.target.value,
            }))
          }
          fullWidth
          variant="filled"
          helperText="Provide a name for the building"
        />
        <DawaAutocomplete
          onLocationSelect={async (location) => {
            if (location && location.data) {
              try {
                const result = await triggerGetLocation(
                  location.data.id,
                ).unwrap();

                if (result) {
                  setFormState((prev) => ({
                    ...prev,
                    Location: {
                      Address: result.adgangsadresse.adressebetegnelse || '',
                      Latitude:
                        result.adgangsadresse.adgangspunkt.koordinater[1],
                      Longitude:
                        result.adgangsadresse.adgangspunkt.koordinater[0],
                    },
                  }));
                }
              } catch (error) {
                console.error('Error fetching location data:', error);
              }
            }
          }}
          value={formState?.Location?.Address || ''}
          placeholder="Vælg adresse"
          disableField={false}
        />
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            required
            type="number"
            name="BaselineDayInterval"
            label="Baseline Day Interval"
            size="small"
            fullWidth
            variant="filled"
            value={formState.BaselineDayInterval}
            helperText="Interval in days for baseline calculation"
            onChange={(e) =>
              setFormState((prev) => ({
                ...prev,
                BaselineDayInterval: e.target.value,
              }))
            }
          />
          <TextField
            required
            name="BaselineDayOffset"
            label="Baseline Day Offset"
            size="small"
            variant="filled"
            fullWidth
            value={formState.BaselineDayOffset}
            onChange={(e) =>
              setFormState((prev) => ({
                ...prev,
                BaselineDayOffset: e.target.value,
              }))
            }
            helperText="Offset in days for the baseline day calculation"
            // type="number"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            // Handle form submission logic here
            handleSubmit();
            onClose();
          }}
          variant="contained"
        >
          Save changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditBuildingDialog;
